<template>
  <div class="banner">
    <!-- 底部白色横线 -->
    <div class="line"></div>
    <!-- 右侧白色竖线 -->
    <div class="vertical-line"></div>
    <!-- 视频核心 -->
    <video
      ref="videoRef"
      class="video"
      muted
      loop
      autoplay
      playsinline
      webkit-playsinline
      x5-video-player-type="h5"
      x5-video-player-fullscreen="true"
      poster="@/assets/images/banner/banner0.gif"
    >
      <source src="@/assets/images/banner/index3.mp4" type="video/mp4" />
      您的浏览器不支持视频播放
    </video>
  </div>
</template>

<script>
export default {
  name: 'Banner',
  mounted() {
    const video = this.$refs.videoRef;
    if (video) {
      video.play().catch((err) => console.log('视频播放兼容处理', err));
    }
  },
};
</script>

<style scoped lang="scss">
.banner {
  width: 100%;
  height: 0;
  // PC端比例
  padding-top: 25.5%;
  min-height: 200px; // 手机最低不会低于220px
  position: relative;
  overflow: hidden;
  background-color: #000;
}

.line {
  height: 15px;
  background-color: #fff;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
}

.vertical-line {
  width: 1px;
  height: 100%;
  background-color: #fff;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 20;
}

.video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  z-index: 1;
}

// 手机屏幕加大高度比例，数值越大越高
@media (max-width: 768px) {
  .banner {
    padding-top: 55%; // 手机拉高，可自行调 50%~65%
  }
  // 手机底部白线缩小一点更协调
  .line {
    height: 8px;
  }
}
</style>
